import { render } from "./ProgramRunner.vue?vue&type=template&id=c4cd649c&scoped=true&ts=true"
import script from "./ProgramRunner.vue?vue&type=script&lang=ts"
export * from "./ProgramRunner.vue?vue&type=script&lang=ts"

import "./ProgramRunner.vue?vue&type=style&index=0&id=c4cd649c&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4cd649c"]])

export default __exports__